// @no-reflective-bind-babel

import React from 'react';
import makeRouteConfig from 'found/lib/makeRouteConfig';
import Route from 'found/lib/Route';
import Redirect from 'found/lib/Redirect';
import { redirectConfig } from './redirectConfig';
/* query */
import {
  FaqPageQuery,
  PrivacyPolicyPageQuery,
  ReturnPageQuery,
  ReceiptPageQuery,
  Shimmer2018PageQuery,
  WeddingsPageQuery,
} from '../queries';
import { routeRedirect } from './routeRedirect';
// import AppQuery from '../queries/App';
/* Full Page Routes */

/* Helpers */
import {
  getSquareRedirectUrl,
  prepareEventPageParams,
  // preparePasswordResetParams,
  prepareBecomeACeoHomePageParams,
  prepareProductCatalogParams,
  prepareReceiptPageParams,
  prepareRelatedProductsParams,
  prepareSSOPageParams,
  lazyLoadCorporatePage,
  lazyLoadProductCatalog,
  prepareCeoHomePageParams,
  lazyLoadCeoHomePage,
  // lazyLoadCEEnrollment,
  lazyLoadChatBot,
  lazyLoadSubscriptionPage,
  // lazyLoadShopLandingPage,
  lazyLoadAboutUsPage,
  lazyLoadAddressesPage,
  lazyLoadAdminPage,
  lazyLoadBecomeACeoPage,
  lazyLoadRewardsPage,
  // lazyLoadBlogPage,
  // lazyLoadBlogPostPage,
  lazyLoadCeoPage,
  // lazyLoadCheckout,
  // lazyLoadDesignGuide,
  lazyLoadEventPage,
  lazyLoadFaqPage,
  lazyLoadGrapefulClubPage,
  lazyLoadGrapefulClubPromo,
  lazyLoadGrapefulClub,
  lazyLoadHomePage,
  lazyLoadHostATastingPage,
  lazyLoadImpactPage,
  lazyLoadMyAccountPage,
  lazyLoadOrdersPage,
  // lazyLoadPasswordResetPage,
  lazyLoadPaymentsPage,
  lazyLoadPrivacyPage,
  lazyLoadRecap2017Page,
  lazyLoadReceiptPage,
  lazyLoadReferralCodeGenerate,
  lazyLoadAccountPage,
  lazyLoadReferralCodeLookup,
  lazyLoadReturnsPage,
  lazyLoadSSOPage,
  lazyLoadSubscriptionSettingsPage,
  lazyLoadShimmer2018Page,
  lazyLoadSipsterhoodPage,
  lazyLoadTrinityLogin,
  lazyLoadThisIsATreePage,
  lazyLoadWeddingsPage,
  lazyLoadWinemakingPage,
  lazyLoadWinemakingPagev2,
  lazyLoadVisitPage,
  renderComponent,
  lazyLoadLoginPage,
  lazyLoadRecoveryPage,
  lazyLoadGroupFundraiserPage,
} from './routeHelper';
import { routeTheGrapefulClub } from '../../server/utils/routeConstants';
import { supercampaignConfig } from './supercampaignConfig';

/* routes */
/* eslint-disable no-confusing-arrow, react/jsx-curly-spacing, react/jsx-space-before-closing */

/* matches:
 * corporate, corporate/
 * corporate/branding, corporate/branding/
 * corporate/build-your-own-gift, corporate/build-your-gift/
 * corporate/custom-shimmer, corporate/custom-shimmer/
 *
 * the variable needs to be in single quotes so that the regex is correct
 */
const corporatePagePath =
  'corporate/:slug(branding|build-your-own-gift|custom-shimmer)?';

/* eslint-disable global-require */
const Routes = makeRouteConfig(
  <Route
    path="/"
    getQuery={() => require('../queries/App').default}
    getComponent={() =>
      import('../components/App/AppComponent').then(module => module.default)
    }
  >
    <Route
      getQuery={() => require('../queries/HomePage').default}
      getComponent={lazyLoadHomePage}
      render={renderComponent}
    />
    <Route
      path="shop/:category"
      getQuery={() => require('../queries/ProductCatalog').default}
      getComponent={lazyLoadProductCatalog}
      prepareVariables={prepareProductCatalogParams}
      render={renderComponent}
    />
    <Route
      path="shop/wine/:category"
      getQuery={() => require('../queries/ProductCatalog').default}
      getComponent={lazyLoadProductCatalog}
      prepareVariables={prepareProductCatalogParams}
      render={renderComponent}
    />
    <Route
      path="shop/sale/:category"
      getQuery={() => require('../queries/ProductCatalog').default}
      getComponent={lazyLoadProductCatalog}
      prepareVariables={prepareProductCatalogParams}
      render={renderComponent}
    />
    <Route
      path="shop/coffee/:category"
      getQuery={() => require('../queries/ProductCatalog').default}
      getComponent={lazyLoadProductCatalog}
      prepareVariables={prepareProductCatalogParams}
      render={renderComponent}
    />
    <Route
      path="shop/kitchen/:category"
      getQuery={() => require('../queries/ProductCatalog').default}
      getComponent={lazyLoadProductCatalog}
      prepareVariables={prepareProductCatalogParams}
      render={renderComponent}
    />
    <Route
      path="shop/gifts/:category"
      getQuery={() => require('../queries/ProductCatalog').default}
      getComponent={lazyLoadProductCatalog}
      prepareVariables={prepareProductCatalogParams}
      render={renderComponent}
    />
    {/* <Route
      path="blog"
      getQuery={() => require('../queries/BlogPage').default}
      getComponent={lazyLoadBlogPage}
      render={renderComponent}
    />
    <Route
      path="blog/:slug"
      getQuery={() => require('../queries/BlogPostPage').default}
      getComponent={lazyLoadBlogPostPage}
      render={renderComponent}
    /> */}
    {/* <Route
      path="check-out"
      getQuery={() => require('../queries/Checkout').default}
      getComponent={lazyLoadCheckout}
      render={renderComponent}
    /> */}
    <Route
      path="join/learn-more"
      getComponent={lazyLoadChatBot}
      render={renderComponent}
    />
    <Route
      path="order/:orderApiId"
      query={ReceiptPageQuery}
      getComponent={lazyLoadReceiptPage}
      render={renderComponent}
      prepareVariables={prepareReceiptPageParams}
    />
    {/*<Route*/}
    {/*  path="recovery"*/}
    {/*  getComponent={lazyLoadPasswordResetPage}*/}
    {/*  query={ResetPasswordPageQuery}*/}
    {/*  render={renderComponent}*/}
    {/*  prepareVariables={preparePasswordResetParams}*/}
    {/*/>*/}
    {/* /!* STATIC PAGE ROUTES *!/*/}
    <Route
      path="impact"
      getComponent={lazyLoadImpactPage}
      render={renderComponent}
    />
    <Route
      path="login"
      getComponent={lazyLoadLoginPage}
      render={renderComponent}
    />
    <Route
      path="recovery"
      getComponent={lazyLoadRecoveryPage}
      render={renderComponent}
    />
    <Route
      path="about-us"
      getComponent={lazyLoadAboutUsPage}
      render={renderComponent}
    />
    <Route
      path="vineyard"
      getComponent={lazyLoadWinemakingPage}
      render={renderComponent}
    />
    <Route
      path="winemaking"
      getComponent={lazyLoadWinemakingPagev2}
      render={renderComponent}
    />
    <Route
      path="visit"
      getComponent={lazyLoadVisitPage}
      render={renderComponent}
    />
    <Route
      path="2017-year-in-review"
      getComponent={lazyLoadRecap2017Page}
      render={renderComponent}
    />
    <Route
      path="this-is-a-tree"
      query={require('../queries/ThisIsATreePage').default}
      getComponent={lazyLoadThisIsATreePage}
      render={renderComponent}
    />
    <Route
      path="faq"
      getComponent={lazyLoadFaqPage}
      query={FaqPageQuery}
      render={renderComponent}
    />
    <Route
      path="returns"
      getComponent={lazyLoadReturnsPage}
      query={ReturnPageQuery}
      render={renderComponent}
    />
    <Route
      path="privacy-policy"
      getComponent={lazyLoadPrivacyPage}
      query={PrivacyPolicyPageQuery}
      render={renderComponent}
    />
    {/*<Route*/}
    {/*  path="recovery"*/}
    {/*  getComponent={lazyLoadPasswordResetPage}*/}
    {/*  prepareVariables={preparePasswordResetParams}*/}
    {/*  query={ResetPasswordPageQuery}*/}
    {/*/>*/}
    <Route
      path="weddings"
      query={WeddingsPageQuery}
      getComponent={lazyLoadWeddingsPage}
      render={renderComponent}
    />
    <Route
      path={corporatePagePath}
      getComponent={lazyLoadCorporatePage}
      query={require('../queries/CorporatePage').default}
      render={renderComponent}
    />
    <Route
      path="sipsterhood"
      getComponent={lazyLoadSipsterhoodPage}
      // query={}
      render={renderComponent}
    />
    <Route
      path="account"
      getComponent={lazyLoadAccountPage}
      query={require('../queries/AccountPage').default}
      render={renderComponent}
    >
      {{
        nav: (
          <Route
            path="(.*)?"
            getComponent={() =>
              import(
                '../components/Layouts/AccountPage/_common/AccountNavigation'
              ).then(module => module.default)
            }
          />
        ),
        main: [
          <Route
            key="account"
            path="/"
            getComponent={lazyLoadMyAccountPage}
            render={renderComponent}
          />,
          <Route
            key="orders"
            path="orders"
            getComponent={lazyLoadOrdersPage}
            render={renderComponent}
          />,
          // <Route
          //   key="favorites"
          //   path="favorites"
          //   getComponent={lazyLoadFavoritesPage}
          //   render={renderComponent}
          // />,
          <Route
            key="addresses"
            path="addresses"
            getComponent={lazyLoadAddressesPage}
            render={renderComponent}
          />,
          <Route
            key="payments"
            path="payments"
            getComponent={lazyLoadPaymentsPage}
            render={renderComponent}
          />,
          <Route
            key="rewards"
            path="rewards"
            getComponent={lazyLoadRewardsPage}
            render={renderComponent}
          />,
          // this route name is misleading - it actually goes to the subscription manager where you can manage your CE subscription
          <Route
            key="subscriptionSettingsAccounts"
            path="subscriptions/preferredCustomer"
            getComponent={lazyLoadSubscriptionSettingsPage}
            render={renderComponent}
          />,
          <Route
            key="subscriptionAccounts"
            path="subscriptions/:subscriptionId?"
            getComponent={lazyLoadSubscriptionPage}
            render={renderComponent}
          />,
        ],
      }}
    </Route>
    <Route
      path="ceo"
      getComponent={lazyLoadCeoPage}
      query={require('../queries/CeoPage').default}
      render={renderComponent}
    >
      {{
        nav: (
          <Route
            path="(.*)?"
            getComponent={() =>
              import(
                '../components/Layouts/CeoPage/_common/CeoNavigation'
              ).then(module => module.default)
            }
          />
        ),
        main: [
          <Route
            key="/"
            path="/"
            getComponent={() =>
              import(
                '../components/Layouts/CeoPage/CeoHomePage/CeoHomePage'
              ).then(module => module.default)
            }
          />,
          <Route
            key="orders"
            path="orders"
            getComponent={() =>
              import(
                '../components/Layouts/CeoPage/CeoOrdersPage/CeoOrdersPage'
              ).then(module => module.default)
            }
          />,
          <Route
            key="events"
            path="events"
            getComponent={() =>
              import(
                '../components/Layouts/CeoPage/CeoConciergePage/CeoConciergePage'
              ).then(module => module.default)
            }
          />,
          <Route
            key="custom"
            path="customers"
            getComponent={() =>
              import(
                '../components/Layouts/CeoPage/CeoCustomersPage/CeoCustomersPage'
              ).then(module => module.default)
            }
          />,
        ],
      }}
    </Route>
    <Route
      path="admin"
      getComponent={lazyLoadAdminPage}
      query={require('../queries/AdminPage').default}
      render={renderComponent}
    >
      {{
        main: [
          <Route
            key="/"
            path="/"
            getComponent={() =>
              import(
                '../components/Layouts/AdminPage/AdminDonationsPage/AdminDonationsPage'
              ).then(module => module.default)
            }
          />,
        ],
      }}
    </Route>
    <Route
      path="referral-code-generate"
      getComponent={lazyLoadReferralCodeGenerate}
      query={require('../queries/ReferralCodeGenerate').default}
      render={renderComponent}
    />
    <Route
      path="host"
      getComponent={lazyLoadHostATastingPage}
      render={renderComponent}
    />
    <Route
      path="referral-code-lookup"
      getComponent={lazyLoadReferralCodeLookup}
      query={require('../queries/ReferralCodeLookup').default}
      render={renderComponent}
    />
    <Route
      path="event/:eventId"
      getComponent={lazyLoadEventPage}
      query={require('../queries/EventPage').default}
      prepareVariables={prepareEventPageParams}
      render={renderComponent}
    />
    <Route
      path="join"
      getComponent={lazyLoadBecomeACeoPage}
      render={renderComponent}
    />
    <Route
      path="myshop/:customUrl"
      getComponent={lazyLoadCeoHomePage}
      prepareVariables={prepareCeoHomePageParams}
      query={require('../queries/CeoHomePage').default}
      render={renderComponent}
    />
    <Route
      path="grapeful-club-signup"
      getComponent={lazyLoadGrapefulClub}
      query={require('../queries/GrapefulClub').default}
      render={renderComponent}
    />
    <Route
      path="preferred"
      getComponent={lazyLoadGrapefulClubPage}
      query={require('../queries/GrapefulClubPage').default}
      render={renderComponent}
    />
    <Route
      path="shimmer"
      getComponent={lazyLoadShimmer2018Page}
      render={renderComponent}
      query={Shimmer2018PageQuery}
    />
    <Route
      path={routeTheGrapefulClub}
      getComponent={lazyLoadGrapefulClubPromo}
      query={require('../queries/GrapefulClubPromo').default}
      render={renderComponent}
    />
    <Route
      path="sso"
      getComponent={lazyLoadSSOPage}
      query={require('../queries/SSOPage').default}
      prepareVariables={prepareSSOPageParams}
      render={renderComponent}
    />
    <Route
      path="trinity-login"
      getComponent={lazyLoadTrinityLogin}
      query={require('../queries/TrinityLogin').default}
      render={renderComponent}
    />

    {/* List of supercampaign slugs */}
    {supercampaignConfig.map(slug => (
      <Route
        path={slug}
        key={`route-${slug}`}
        getComponent={lazyLoadGroupFundraiserPage}
        query={require('../queries/GroupFundraiserPage').default}
        render={renderComponent}
      />
    ))}

    {/* <Redirect from="checkout" to="/check-out" /> */}
    <Redirect from="become-a-ceo" to="/join" />
    <Redirect from="IWD" to="/join" />
    <Redirect from="host-a-tasting" to="/host" />
    <Redirect from="square" to={getSquareRedirectUrl} />
    {redirectConfig.map(({ from, to }) => (
      <Redirect key={from} from={from} to={routeRedirect(to)} />
    ))}
    <Redirect from="*" to="/" />
  </Route>,
);

export default Routes;
